export const POSTAL_DELIVERY_EXTERNAL_REFERENCE = 'voucher-postal-delivery'

export class LineItem {

    constructor(
        public id: string,
        public name: string,
        public skuId: string,
        public amount: number,
        public quantity: number,
        public externalReference: string | null,
        public modifiers: { name: string; amount: number; quantity: number }[] = [],
        public customerRefundableUntil: Date | null = null,
        public paidOnline: boolean = true
    ) { }

    unitAmount(): number {
        if (!this.paidOnline) {
            return 0
        }
        return this.amount + this.modifiers.reduce((total, modifier) => total + modifier.amount * modifier.quantity, 0)
    }

    get isPostalDeliveryFee(): boolean {
        return this.externalReference === POSTAL_DELIVERY_EXTERNAL_REFERENCE
    }
}
